export default {
  namespaced: true,
  state: {
    coursesList: [],
    course: {},
    try: null,
    testsList: [],
    testResultsList: [],
  },
  actions: {
    GetCoursesList({ commit, rootGetters, dispatch }, profileId) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('courses/api/course/list', { profile_id: profileId })
          .then((response) => {
            if (response && response.data) {
              commit('InitialStoreCourses');
              commit('setCoursesList', response.data.courses);
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetCourse({ commit, rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('courses/api/course/view', {
          course_id: payload.course_id,
          profile_id: payload.profile_id,
        })
          .then((response) => {
            if (response && response.data) {
              commit('setCourse', response.data.course);
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    async startTry({ commit, rootGetters }, payload) {
      commit('setTry', null);
      try {
        const response = await rootGetters.ax.post('courses/api/test-try/index', {
          profile_id: payload.profile_id,
          test_id: payload.test_id,
        });
        if (!response || !response.data) throw new Error('Test attempt response is missing');
        commit('setTry', response.data.try);
        return response.data;
      } catch (error) {
        // The API uses 301 when the participant has reached the attempt limit.
        if (error.response && error.response.status === 301 && error.response.data.redirect) {
          return { try: null };
        }
        throw error;
      }
    },
    GetResultsList({ commit, rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('courses/api/test-try/list', { profile_id: payload.profile_id, test_id: payload.test_id })
          .then((response) => {
            if (response && response.data) {
              commit('setResultsList', response.data.tries);
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreCourses({ commit }) {
      commit('InitialStoreCourses');
    },
  },
  mutations: {
    setCoursesList(state, payload) {
      state.coursesList = payload;
    },
    setCourse(state, payload) {
      state.course = payload;
    },
    setResultsList(state, payload) {
      state.testResultsList = payload;
    },
    setTry(state, payload) {
      state.try = payload;
    },
    InitialStoreCourses(state) {
      state.coursesList = [];
      state.course = {};
      state.try = null;
      state.testsList = [];
      state.testResultsList = [];
    },
  },
};
